import { styled } from "@linaria/react";
import { StyledProductsGrid } from "@/components/Products/StyledProductsGrid";
import { ButtonGroup } from "@/ui/Button/StyledButton";
export const StyledFavorites = /*#__PURE__*/styled('div')({
  name: "StyledFavorites",
  class: "StyledFavorites_s1jdz2ql"
});
export const StyledGroupsTagsWrapper = /*#__PURE__*/styled('div')({
  name: "StyledGroupsTagsWrapper",
  class: "StyledGroupsTagsWrapper_s1xgk9vc"
});

require("./Styled.linaria.module.css!=!../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./Styled.tsx");